export default {
  currency(value: number) {
    return Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(value)
  },
}
